export enum MenuGroups {
  Move = 'move',
  Lifecycle = 'lifecycle',
}

export enum SubMenu {
  MoveGoal = 'move-goal',
}
